import React from "react";
import { ModalDataItem } from "../../../ducks/app";
import { Button } from "../../atoms/Button";
import { CloseButton } from "../../atoms/CloseButton";
import {
  ModalButtonContainer,
  ModalContainer,
  ModalSubtitle,
  ModalSubtitleContainer,
  ModalTitle,
  ModalTitleContainer,
  ModalWarning,
  PopupModalContainer,
} from "./PopupModal.styles";

type Props = ModalDataItem & {
  isOpen: boolean;
  defaultCloseModal: () => void;
};

export const PopupModal: React.FC<Props> = ({
  isOpen,
  title,
  subTitle,
  warningText,
  showXIcon,
  closeButtonLabel,
  nextButtonLabel,
  handleClose,
  handleNext,
  defaultCloseModal,
}) => {
  if (!isOpen) return null;

  return (
    <PopupModalContainer $isOpen={isOpen}>
      <ModalContainer $isOpen={isOpen}>
        {showXIcon && <CloseButton onClick={handleClose}></CloseButton>}

        <ModalTitleContainer>
          <ModalTitle>{title}</ModalTitle>
        </ModalTitleContainer>

        {subTitle && (
          <ModalSubtitleContainer>
            {typeof subTitle === "string" ? (
              <ModalSubtitle>{subTitle}</ModalSubtitle>
            ) : (
              subTitle
            )}
          </ModalSubtitleContainer>
        )}

        {warningText && (
          <ModalSubtitleContainer>
            <ModalWarning>{warningText}</ModalWarning>
          </ModalSubtitleContainer>
        )}

        <ModalButtonContainer>
          {nextButtonLabel && (
            <Button
              btnStyle="primary"
              onClick={handleNext ?? defaultCloseModal}
              text={nextButtonLabel}
            />
          )}
          {closeButtonLabel && (
            <Button
              btnStyle="secondary"
              onClick={handleClose ?? defaultCloseModal}
              text={closeButtonLabel}
            />
          )}
        </ModalButtonContainer>
      </ModalContainer>
    </PopupModalContainer>
  );
};
